import React from 'react';
import { Link } from 'react-router-dom';

const List = ({ title, content }) => {
  return (
    <div className="mb-10">
      <h5 className="mb-[19px] text-base font-semibold text-neutral-900">{title}</h5>
      <ul className="m-0 list-none p-0">
        {content.map((item, index) => (
          <li key={`footer-list-${index}`} className="mb-2 text-sm font-light text-neutral-600">
            {typeof item === 'string' ? (
              item
            ) : (
              <Link to={item.to} className="transition hover:text-primary">
                {item.label}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default List;
